import { FC, PropsWithChildren, ReactNode } from 'react';

import { useLinkComponent } from '@eneco/link';
import { Box, Card, Divider, Grid, Heading, Stack, Stretch, TextLink } from '@eneco/sparky';

interface Props extends PropsWithChildren {
  buttonLink?: string;
  buttonLinkType?: string;
  buttonText?: string;
  title?: string | ReactNode;
  customCta?: ReactNode;
  closeIcon?: ReactNode;
}

export const StretchBucket: FC<Props> = ({
  buttonLink,
  buttonLinkType = 'internal',
  buttonText,
  children,
  customCta,
  title,
  closeIcon,
}) => {
  const Link = useLinkComponent();
  const showButton = buttonLink && buttonText && !customCta;
  let cardTitle = title;

  if (typeof title === 'string') {
    cardTitle = (
      <Box paddingBottom="4" paddingTop="5" paddingX="6">
        <Heading size="3XS" as={'h2'}>
          {title}
        </Heading>
      </Box>
    );
  }

  return (
    <Card as="section">
      <Stretch height>
        <Stack>
          <Grid gridTemplateColumns={{ sm: '7fr 1fr' }}>
            {title && <Grid.Item>{cardTitle}</Grid.Item>}
            {closeIcon && <Grid.Item alignSelf="center">{closeIcon}</Grid.Item>}
          </Grid>
          <Divider />
          <Stack.Item grow>
            <Stretch height>
              <Box padding="6">
                <Stretch height>
                  <Stack gap="10">
                    <Stack.Item grow>{children}</Stack.Item>
                    {showButton && (
                      <Stack.Item>
                        <Link href={buttonLink} linkType={buttonLinkType}>
                          <TextLink emphasis="high">{buttonText}</TextLink>
                        </Link>
                      </Stack.Item>
                    )}
                    {customCta && <Stack.Item>{customCta}</Stack.Item>}
                  </Stack>
                </Stretch>
              </Box>
            </Stretch>
          </Stack.Item>
        </Stack>
      </Stretch>
    </Card>
  );
};
